import { PDF } from '../types';

const initialState = {
  showDialog: false,
  assignId: null,
};

const pdfReducer = (state = initialState, action) => {
  switch (action.type) {
    case PDF.SHOW_PDF_DIALOG:
      return {
        showDialog: true,
        assignId: action.payload,
      };

    case PDF.HIDE_PDF_DIALOG:
      return {
        showDialog: false,
        assignId: null,
        pdfProps: null,
      };

    default:
      return state;
  }
};

export default pdfReducer;